(ns io.daskul.tutorial.webapp.views.boot-splash
  "Branded boot splash for the readiness gate (SMS-70).

   :loading → the Klei mark sits solid and gently breathes while the amber
   signature dot orbits it (pure CSS, animates transform/opacity only — safe to
   run pre-mount). The status line fades in after ~150ms so a fast boot never
   flashes it, and escalates to 'Still working…' if the boot drags on.
   prefers-reduced-motion → the orbit/breathe stop and a static dot shows.

   :error → a hard-required fetch (config) failed; offer Retry, which
   re-dispatches ::bootstrap. Never an infinite spinner."
  (:require
   [uix.core :refer [defui $ use-state use-effect]]
   [uix.re-frame :as urf]
   [re-frame.core :as rf]
   [io.daskul.webapp.bootstrap :as bootstrap]
   [io.daskul.tutorial.webapp.domain.auth.subs :as auth.subs]
   [io.daskul.tutorial.webapp.domain.bootstrap.events :as bootstrap.events]))

(defui klei-splash-mark
  "The Klei mark with the orbiting amber dot, built inside the SVG so the orbit
   anchors to the mark's own view-box centre (an HTML-overlay orbit was found to
   break in Chrome). Geometry is the brand-kit icon (klei-icon.svg) inlined so
   body and dot can animate as separate nodes; keep it in sync with the kit.
   Classes are styled + reduced-motion-handled in styles.css."
  []
  ($ :svg {:class "klei-splash-mark" :viewBox "0 0 512 512"
           :role "img" :aria-label "Klei"}
    ($ :g {:class "ksm-body"}
      ($ :rect {:width 512 :height 512 :rx 114.53 :fill "#7536E9"})
      ($ :g {:transform "translate(87.28,76.44) scale(2.373667) translate(-16.14,-5.01)"}
        ($ :path {:d "M31.84 20.71L31.84 140.30" :stroke "#FFFFFF" :stroke-width 31.40
                  :stroke-linecap "round" :stroke-linejoin "round" :fill "none"})
        ($ :path {:d "M92.44 70.05L34.07 119.10" :stroke "#FFFFFF" :stroke-width 31.40
                  :stroke-linecap "round" :stroke-linejoin "round" :fill "none"})
        ($ :path {:d "M57.47 103.13L95.09 140.30" :stroke "#FFFFFF" :stroke-width 31.40
                  :stroke-linecap "round" :stroke-linejoin "round" :fill "none"})))
    ;; Static dot — only shown under prefers-reduced-motion (see styles.css).
    ($ :g {:class "ksm-dot-static"
           :transform "translate(87.28,76.44) scale(2.373667) translate(-16.14,-5.01)"}
      ($ :circle {:cx 143.02 :cy 141.02 :r 15.28 :fill "#F29512"}))
    ;; Orbiting dot — the signature motion.
    ($ :g {:class "ksm-orbit"}
      ($ :circle {:cx 256 :cy 54.4 :r 38.4 :fill "#F29512"}))))

(defui boot-loading
  "The :loading splash. `slow?` flips true after a few seconds to escalate copy."
  []
  (let [[slow? set-slow!] (use-state false)]
    (use-effect
     (fn []
       (let [t (js/setTimeout #(set-slow! true) 6000)]
         (fn [] (js/clearTimeout t))))
     [])
    ($ :div {:class "boot-splash"}
      ($ klei-splash-mark)
      ($ :div {:class "boot-splash-status"}
        (bootstrap/status-copy slow?)))))

(defui boot-error
  "The :error splash — a hard-required fetch failed. Retry re-runs ::bootstrap."
  []
  (let [user (urf/use-subscribe [::auth.subs/current-user])
        retry (fn []
                (rf/dispatch [::bootstrap.events/bootstrap
                              {:school-id (:school-id user)
                               :branch-id (:branch-id user)}]))]
    ($ :div {:class "boot-splash"}
      ($ klei-splash-mark)
      ($ :div {:class "boot-splash-status"} "Couldn't load — something went wrong.")
      ($ :button {:class "boot-splash-retry" :type "button" :onClick retry}
        "Retry"))))
